<template>
  <div
    :style="[(params.activeBackgroundQr && params.colorOrImageQr === 'imagen') ? {'background-image': 'url(' + vendor.qrBackground + ')'} : (params.activeBackgroundQr && params.colorOrImageQr === 'color') ? {backgroundColor:vendor.qrBackground}: '',{height:height + 'px'}]"
    id="menuDigital"
    v-if="params.isActiveMenuDigital != 0"
  >
    <section class="mainContent" :class="{smallDevices:height < 650}">
      <CustomVars></CustomVars>
      <BannerCarousel v-if="params.bannerActiveMenuDigital"></BannerCarousel>
      <div
        :class="{'position-absolute-back': params.bannerActiveMenuDigital && existBanner}"
        @click="back()"
        class="back"
        id="btn-back-menu"
        v-if="active !== 1 && params.typeMenuDigital == 'intermediate'"
      >
        <i class="img-back"></i>
      </div>
      <div
        :class="{'position-absolute-back': params.bannerActiveMenuDigital && existBanner}"
        @click="back()"
        class="back"
        id="btn-back-menu"
        v-if="active !== 1 && params.typeMenuDigital == 'advanced'"
      >
        <i class="img-back"></i>
      </div>
      <div
        :class="{
          'mb-content-logo': active === 6,
          'mt-negative-carousel':
            params.bannerActiveMenuDigital === 1 && existBanner,
          'is-hidden':(params.typeMenuDigital == 'basic' || params.typeMenuDigital == 'medium')
        }"
        class="content-logo-restaurant"
        v-if="active !== 61 && active !== 2"
      >
        <div
          :style="{ 'background-image': `url('${vendor.lightLogoURL}')` }"
          class="logo backImage"
          v-if="active !== 4 &&
            active !== 5 &&
            active !== 61 &&
            params.typeMenuDigital == 'intermediate'"
        ></div>
        <div
          :style="{ 'background-image': `url('${vendor.lightLogoURL}')` }"
          class="logo multi-logo backImage"
          v-if="active == 1 && params.typeMenuDigital == 'advanced'"
        ></div>
      </div>
      <div
        style="width: 100%;"
        data-id="basic"
        v-if="
          params.typeMenuDigital == 'basic' || params.typeMenuDigital == 'medium'
        "
      >
        <Carta v-if="params.optionCustomMenu === 0"></Carta>
        <CustomMenu v-if="params.optionCustomMenu === 1"></CustomMenu>
      </div>
      <div v-if="active === 1 && (params.typeMenuDigital == 'intermediate')" class="startText">
        <span class="text bold-strong size-18" :class="{isWhite:params.activeFooterMenuDigitalWhite == 0}">{{ titleStarText }}</span>
        <span class="text bold size-12 margin-bot-40" :class="{isWhite:params.activeFooterMenuDigitalWhite == 0}"
          >{{ subtitleStarText }}</span
        >
      </div>
      <div
        :class="{ 'width-100': active == 6, 'h-100': active == 9 }"
        style="width: 100%;"
        data-id="intermediate"
        v-if="params.typeMenuDigital == 'intermediate'"
      >

      <StartMenu @activeView="active = $event" @image="images = $event" v-if="active == 1"></StartMenu>
      <Form @activeView="active = $event" v-if="active == 2"></Form>
      <Offices @activeView="active = $event" v-if="active == 9"></Offices>
      <Success v-if="active == 3"></Success>
      <Carta v-if="active == 4"></Carta>
      <ImageOpen :images="images" v-if="active == 5"></ImageOpen>
      <MultiMenu
        @activeView="active = $event"
        @menuSelected="onMenuSelected($event)"
        v-if="active == 6"
      ></MultiMenu>
      <MenuSelected :menu="menu" v-if="active == 61"></MenuSelected>
      </div>
      <div
        :class="{ 'width-100': active == 1 }"
        style="width: 100%;"
        data-id="advanced"
        v-if="params.typeMenuDigital == 'advanced' && params.multiMenu"
      >
        <MultiMenu
          @activeView="active = $event"
          @menuSelected="onMenuSelected($event)"
          v-if="active == 1"
        ></MultiMenu>
        <MenuSelected :menu="menu" v-if="active == 2"></MenuSelected>
      </div>
      <div
        :class="{
          multi: params.isLogoDlk == 1,
          'color-crepes': params.activeSelectorFooterMenuDigital == 1,
          'no-personalized': params.activeSelectorFooterMenuDigital == 0,
          'footer-white-digital': params.activeFooterMenuDigitalWhite == 1,
          'footer-height-dlk':params.isLogoDlk === 1
        }"
        class="footer-menu"
      >
        <div class="socials 2" v-if="vendor.facebook || vendor.twitter || vendor.instagram || vendor.whatsapp">
          <i @click="openSocial('facebook')" class="icon_facebook" v-if="vendor.facebook" :style="{background: getColor()}"></i>
          <i @click="openSocial('twitter')" class="icon_twitter" v-if="vendor.twitter" :style="{background: getColor()}"></i>
          <i @click="openSocial('instagram')" class="icon_instagram" v-if="vendor.instagram" :style="{background: getColor()}"></i>
          <i @click="openSocial('whatsapp')" class="icon_whatsapp" v-if="vendor.whatsapp" :style="{background: getColor()}"></i>
        </div>
        <img
          :alt="vendor.displayName"
          class="dlkImg"
          src="@/assets/images/menuDigital/logo_dlk-white.png"
          v-if="params.isLogoDlk == 1"
          style="margin-bottom:15px'"
        />
        <img
          alt="logo-footer-crepes"
          class="text-center logo-footer-crepes"
          src="@/assets/images/menuDigital/logo-footer-crepes.png"
          v-if="params.activeSelectorFooterMenuDigital == 1"
        />
        <img
          alt="logo-precompro"
          class="logo-footer-pre"
          src="@/assets/images/menuDigital/logo-footer-precompro.svg"
          v-if="params.activeFooterMenuDigitalWhite == 0 || params.isLogoDlk == 1 || params.activeSelectorFooterMenuDigital == 1"
        />
        <img
          alt="logo-precompro"
          class="logo-footer-pre"
          src="@/assets/images/menuDigital/logo_footer_precompro_white.svg"
          v-else-if="params.activeFooterMenuDigitalWhite == 1"
        />
      </div>
    </section>
  </div>
</template>
<script>
import StartMenu from '@/components/menuDigital/start';
import Form from '@/components/menuDigital/form';
import Success from '@/components/menuDigital/success';
import Carta from '@/components/menuDigital/carta';
import ImageOpen from '@/components/menuDigital/imageOpen';
import MultiMenu from '@/components/menuDigital/multiMenu';
import MenuSelected from '@/components/menuDigital/multiMenuMenu';
import Offices from '@/components/menuDigital/offices';
import CustomVars from '@/components/customVars';
import CustomMenu from '@/components/menuDigital/customMenu';
import ModalImage from '../components/menuDigital/modalBody/modalImage.vue';
import ModalMotul from '../components/menuDigital/modalBody/modalMotul.vue';
import BannerCarousel from '@/components/menuDigital/bannerCarousel/bannerCarousel.vue';
import { mapGetters } from 'vuex';
import whiteLabelTypes from '@/store/types/whiteLabel';
import globalTypes from '@/store/types/global';
import { menuMetrics } from '@/helpers/apis/metrics.js';

export default {
  components: {
    BannerCarousel,
    StartMenu,
    Form,
    Success,
    Carta,
    MultiMenu,
    MenuSelected,
    ImageOpen,
    Offices,
    CustomVars,
    CustomMenu
  },
  data () {
    return {
      height: 0,
      active: 1,
      menu: [],
      images: null,
      popClosedCustom: false,
      radio: false,
      data: {
        email: '',
        phone: '',
        name: ''
      },
      titleStarText: '¿Qué quieres hacer hoy?',
      subtitleStarText: 'Selecciona una de las opciones para continuar'
    };
  },
  computed: {
    ...mapGetters({
      existBanner: [whiteLabelTypes.getters.getExistBanner],
      integrations: [whiteLabelTypes.getters.integrations],
      integrationDefaults: [whiteLabelTypes.getters.integrationDefaults]
    }),
    getAvailableLang () {
      return (value) => {
        if (this.params.availableLanguages && this.params.availableLanguages !== null) {
          const arrayLangs = this.params.availableLanguages.split(',');
          if (arrayLangs.find(lang => lang === value)) {
            return true;
          }
          return false;
        }
        return true;
      };
    }
  },
  watch: {
    integrations () {
      this.loadScript(this.integrations);
    },
    integrationDefaults () {
      this.loadScriptDefault(this.integrationDefaults);
    }
  },
  mounted () {
    this.height = window.innerHeight;
    if (
      this.vendor.id === 289 ||
      this.vendor.id === 303 ||
      this.vendor.id === 309
    ) {
      this.popUpMotul();
    }
    const validationShowModal = this.getValidationPopUpMsg();
    if (validationShowModal && this.params.activeModalWithImageMenuDigital) {
      this.popCustom();
    }
    this.getBanners();
    const origins = this.$route.query;
    const utmParams = this.getUTMParams();
    if (Object.keys(origins).length > 0) {
      if (origins.origin !== undefined) {
        if (Object.keys(utmParams).length > 0) {
          menuMetrics(origins.source, origins.origin, utmParams);
        } else {
          menuMetrics(origins.source, origins.origin);
        }
      } else {
        if (Object.keys(utmParams).length > 0) {
          menuMetrics(null, null, utmParams);
        }
      }
    }
    if (this.params.titleMenuDigitalStartText) {
      this.titleStarText = this.params.titleMenuDigitalStartText;
    }
    if (this.params.subtitleMenuDigitalStartText) {
      this.subtitleStarText = this.params.subtitleMenuDigitalStartText;
    }
  },
  beforeUpdate () {
    if (this.params.bannerActiveMenuDigital === 1 && this.existBanner) {
      window.addEventListener('scroll', () => {
        this.postionBtnBack();
      });
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.postionBtnBack());
  },
  methods: {
    getUTMParams () {
      const params = new URLSearchParams(window.location.search);
      const utmData = {};

      params.forEach((value, key) => {
        if (key.startsWith('utm_')) {
          utmData[key] = value;
        }
      });

      return utmData;
    },
    getValidationPopUpMsg () {
      const currentDate = this.$moment().format('YYYY-MM-DD');
      const currentTime = this.$moment().format('HH:mm');

      // Valores de rango
      const startDate = this.vendor.startDateQr;
      const endDate = this.vendor.endDateQr; // Puede ser null
      const startHour = this.vendor.startHourQr;
      const endHour = this.vendor.endHourQr; // Puede ser null
      const alertOnboardingToShow = () => {
        let isStartDateHourMatch = true;
        let isEndDateHourMatch = true;

        // Validar inicio: fecha y hora inicial deben coincidir
        if (startDate !== null && startDate !== '') {
          if (currentDate === startDate) {
            // Si es el día de la fecha inicial, validar la hora inicial
            isStartDateHourMatch = startHour === null || currentTime >= startHour;
          } else {
            // Validar solo la fecha inicial (sin considerar la hora)
            isStartDateHourMatch = currentDate >= startDate;
          }
        }

        // Validar final: fecha y hora final deben coincidir
        if (endDate !== null && endDate !== '') {
          if (currentDate === endDate) {
            // Si es el día de la fecha final, validar la hora final
            isEndDateHourMatch = endHour === null || currentTime < endHour;
          } else {
            // Validar solo la fecha final (sin considerar la hora)
            isEndDateHourMatch = currentDate <= endDate;
          }
        }
        // Ambas condiciones deben cumplirse
        return isStartDateHourMatch && isEndDateHourMatch;
      };
      return alertOnboardingToShow();
    },
    onMenuSelected (event) {
      this.menu = event;
      const mainContent = document.querySelector('.mainContent');
      if (mainContent) {
        mainContent.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    getColor () {
      if (this.params.activeFooterMenuDigitalWhite === 1 && this.params.isLogoDlk === 1) {
        return 'white';
      } else {
        return (this.params.activeFooterMenuDigitalWhite === 1) ? 'black' : 'white';
      }
    },
    postionBtnBack () {
      const btnBack = document.getElementById('btn-back-menu');
      if (window.scrollY >= 149 && btnBack) {
        btnBack.classList.add('position-fixed-back');
      } else if (btnBack) {
        btnBack.classList.remove('position-fixed-back');
      }
    },
    getBanners () {
      this.$store.dispatch({
        type: 'whiteLabel:actionListBannersMenu',
        data: { id: this.vendor.id }
      });
    },
    popCustom () {
      this.$buefy.modal.open({
        parent: this,
        component: ModalImage,
        hasModalCard: true,
        customClass: 'modal-img-custom'
      });
    },
    popUpMotul () {
      this.$buefy.modal.open({
        parent: this,
        component: ModalMotul,
        hasModalCard: true,
        customClass: 'modal-closed'
      });
    },
    back () {
      if (this.active === 61) {
        this.active = 6;
      } else {
        this.active = 1;
      }
    },
    openSocial (social) {
      if (social === 'facebook') {
        window.open(this.vendor.facebook);
      } else if (social === 'twitter') {
        window.open(this.vendor.twitter);
      } else if (social === 'instagram') {
        window.open(this.vendor.instagram);
      } else if (social === 'whatsapp') {
        window.open(`https://wa.me/${this.vendor.whatsapp}`);
      }
    },
    setTypeLanguage (type) {
      this.$store.commit(globalTypes.mutations.setMultiLanguage, type);
    }
  }
};
</script>
<style lang="scss">
@import "../assets/styles/MenuDigital/styles.scss";
</style>
